import ReactDOM from "react-dom";
import React, { useState } from "react";
import "./App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Dashboard from "./Component/Dashboard";
import AssignRole from "./Component/AssignRole";
import Notification from "./Component/Notification";
import NoticeForm from "./Component/NoticeForm";
import Member from "./Component/Member";
import Receipt from "./Component/Receipt";
import CircularNotice from "./Component/CircularNotice";
import CreditNote from "./Component/CreditNote";
import MemberBill from "./Component/MemberBill";
import Report from "./Component/Report";
import ServiceProvider from "./Component/ServiceProvider";
import DebitNote from "./Component/DebitNote";
import NotificationSent from "./Component/NotificationSent";
import CreateDebitNote from "./Component/CreateDebitNote";
import CreateAssignRole from "./Component/CreateAssignRole";
import AddEmployee from "./Component/AddEmployee";
import MemberTable from "./Component/MemberTable";
import Compose from "./Component/Compose";
import ServiceProviderForm from "./Component/ServiceProviderForm";
import UploadMenu from "./Component/UploadMenu";
import RoleManagement from "./Component/RoleManagement";
import GetMemeberRecord from "./Component/GetMemeberRecord";
import { FilterProvider } from "./Component/FilterContext";
import Bill from "./Component/bill";
import MemberLadger from "./Component/MemberLadger";
import MemberDebitNote from "./Component/MemberDebitNote";
import MemberCreditNote from "./Component/memberCreditNote";
import MemberReciept from "./Component/MemberReciept";
import ProfilePage from "./Component/Profile";
import Logout from "./Component/Logout";
import ChatPage from "./Component/ChatPage";
import Emergency from "./Component/Emergency";
import EmergencyList from "./Component/EmergencyList";
import EditEmergency from "./Component/EditEmergency";
import Charges from "./Component/Charges";
import ReportPage from "./Component/ReportPage";
import Archive from "./Component/Archive";
import { jwtDecode } from "jwt-decode";
import PrivateRoute from "./Component/PrivateRoute";
import { BASE_URL } from "./Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DowloadPDF from "./Component/DowloadPDF";
import ComplatntsRegister from "./Component/ComplatntsRegister";
import QRScaner from "./Component/QRScaner";
import QRpage from "./Component/QRpage";
import BillLists from "./Component/billLists";
import ParkingList from "./Component/ParkingList";
import Opening from "./Component/Opening";
import Visitor from "./Component/Visitor";
import Vouchers from "./Component/Vouchers";
import AddVouchers from "./Component/AddVouchers";
import AadvancePayment from "./Component/AdavancePayment";
import DynamicForm from "./Component/DynamicForm";
import Documents from "./Component/Documents";
import DocumentsList from "./Component/DocumentsList";
import DocumentDetails from "./Component/DocumentDetails";
import AddBankDetails from "./Component/AddBankDetails";
import BankDetails from "./Component/BankDetails";
import HistoryMember from "./Component/HistoryMember.js";
import HistroyCredit from "./Component/HistroyCredit";
import DeleteDebitNote from "./Component/DeleteDebitNote.js";
import OpeningHistroy from "./Component/OpeningHistory";
import HistroyReceipt from "./Component/HistroryReceipt.js";
import ParkingHistory from "./Component/ParkingHistory";
import AadvancePaymentDeleted from "./Component/AadvancePaymentDeleted.js";
import BillDeleted from "./Component/BillDeleted.js";
import HistroyDeleteRecord from "./Component/HistoryDeletedRecord.js";
import VisitorHistroy from "./Component/VisitorHistroy.js";
import PreviousYearBill from "./Component/PreviousYearBills.js";
import PreviousYearReceipt from "./Component/PreviousYearReceipts.js";
import PreviousYearCreditNotes from "./Component/PreviousYearCreditNotes.js";
import PreviousYearDebitNotes from "./Component/PreviousYearDebitNotes.js";
import PreviousYearOpeningBalances from "./Component/PreviousYearopeningBalances.js";
import PreviousYearAdvancePayment from "./Component/PreviousYearAdvancePayments.js";
import CurrentlyYearLedger from "./Component/CurrentlyYearLedger.js";
import FinancialYearDynamically from "./Component/FinancialYearDynamically.js";
import PerviousYearLedger from "./Component/PerviousYearLedger.js";
import PdfTutorialModal from "./Component/PdfTutorialModal.js";
import HelpSupport from "./Component/HelpSupport.js";
import RatingEmp from "./Component/RatingEmp.js";
import MemberRquest from "./Component/MemberRquest.js";
import Rules from "./Component/Rules.js";
import ManageRules  from "./Component/ManageRules.js";
import PDFBuilder from "./Component/PDFBuilder.js";
import UploadManager from "./Component/UploadManager.js";
import PdfGuideLine from "./Component/PdfGuideLine.js";
import PdfGuideLineList from "./Component/PdfGuideLineList.js";
import Transaction from "./Component/Transaction.js";
import Interest from "./Component/Interest.js";
import AllInterest from "./Component/AllInterest.js";
import BillMaster from "./Component/BillMaster.js";
import GenerateBill from "./Component/GenerateBill.js";
import UploadMaster from "./Component/UploadMaster.js";
import MemberInterestCharges from "./Component/MemberInterestCharges.js";
import MasterReceipt from "./Component/MasterReceipt.js";
import SocietyBatchBills from "./Component/SocietyBatchBills.js";
import MasterLedger from "./Component/MasterLedger.js";
import MasterOldBill from "./Component/MasterOldBill.js";
import PendingBill from "./Component/PendingBill.js";
import LadgerEdit from "./Component/LadgerEdit.js";
import LadgerDetails from "./Component/LedgerDetails.js";

import {
  Mail,
  Lock,
  Eye,
  EyeOff,
  ArrowRight,
  Building2,
  CheckCircle2,
  ShieldCheck,
} from "lucide-react";



function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
   

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError("");
      const response = await axios.post(`${BASE_URL}/api/login`, {
        email,
        password,
      });

      const token = response.data.token;

      if (!token) {
        setLoading(false);
        setError("Login failed. Token not received.");
        return;
      }
      localStorage.setItem("email", email);
      localStorage.setItem("password", password);
      localStorage.setItem("token", token);
      localStorage.setItem("email", email);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      let decoded = null;
      try {
        decoded = jwtDecode(token);
      } catch (decodeErr) {
        setLoading(false);
        setError("Invalid token format.");
        return;
      }

      const role = decoded?.role ? String(decoded.role).toUpperCase() : null;
      if (role !== "ADMIN") {
        setLoading(false);
        toast.error("You are not authorized to access the admin dashboard.", {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }

      localStorage.setItem("role", role);
      // if (decoded.society) localStorage.setItem("society", decoded.society);
      if (decoded.society) {
      const formattedSociety = decoded.society;
       localStorage.setItem("society", formattedSociety);
      }
      if (decoded.societyRegNo)
        localStorage.setItem("societyRegNo", decoded.societyRegNo);

      setLoading(false);
       setShowPdf(true);
      toast.success("Login successful!", {
        position: "top-right",
        autoClose: 3000,
      });
      
      // navigate("/dashboard");
    } catch (err) {
      setLoading(false);
      setError("Invalid credentials or server error");
      toast.error("Invalid credentials or server error", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="login-page-premium">
      <div className="login-card-premium">
        <div className="login-brand-section">
          <div className="brand-glow-effect"></div>
          <div className="brand-content-wrapper">
            <div className="brand-header">
              <div className="brand-logo-box">
                <Building2 size={32} color="#ffffff" />
              </div>
              <h1>
                Society
                <br />
                Admin Portal
              </h1>
            </div>

            <div className="brand-features-list">
              <div className="brand-feature">
                <div className="feature-icon">
                  <CheckCircle2 size={18} />
                </div>
                <div className="feature-text">
                  <h3>Smart Management</h3>
                  <p>Streamline operations with automated tools</p>
                </div>
              </div>
              <div className="brand-feature">
                <div className="feature-icon">
                  <ShieldCheck size={18} />
                </div>
                <div className="feature-text">
                  <h3>Secure & Reliable</h3>
                  <p>Enterprise-grade security for your data</p>
                </div>
              </div>
            </div>

            <div className="brand-footer">
              <p>Powered by</p>
              <img
                src="https://www.zapsolutionz.com/ZAP%20WMS%20R.png"
                alt="ZAP Solutionz"
                className="zap-logo"
              />
            </div>
          </div>
        </div>

        <div className="login-form-section">
          <div className="form-header text-red-400">
            <h2>Welcome Back</h2>
            <p>Please enter your details to sign in</p>
          </div>

          <form onSubmit={handleSubmit} className="premium-form">
            <div className="input-group-premium">
              <label>Email Address</label>
              <div className="input-wrapper">
                <Mail className="field-icon" size={20} />
                <input
                  type="email"
                  placeholder="admin@society.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="input-group-premium">
              <label>Password</label>
              <div className="input-wrapper">
                <Lock className="field-icon" size={20} />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <div className="form-options">
              <label className="custom-checkbox">
                <input type="checkbox" />
                <span className="checkmark"></span>
                <span>Remember me</span>
              </label>
              <a href="#" className="forgot-link">
                Forgot Password?
              </a>
            </div>

            {error && (
              <div className="error-message-premium">
                <div className="error-dot"></div>
                {error}
              </div>
            )}

            <button
              type="submit"
              className="submit-btn-premium"
              disabled={loading}
            >
              {loading ? (
                <span className="loading-text">Signing in...</span>
              ) : (
                <>
                  <span>Sign In</span>
                  <ArrowRight size={20} />
                </>
              )}
            </button>
              <PdfTutorialModal
              isOpen={showPdf}
              onClose={() => {
              setShowPdf(false);
               navigate("/dashboard");   
            }}
            />
          </form>
        </div>
      </div>
    </div>
  );
}

function App() {
  
  return (
    <React.StrictMode>
      <FilterProvider>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />

        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/assign-role"
              element={
                <PrivateRoute>
                  <AssignRole />
                </PrivateRoute>
              }
            />
            <Route
              path="/notification"
              element={
                <PrivateRoute>
                  <Notification />
                </PrivateRoute>
              }
            />
            <Route
              path="/notice-form"
              element={
                <PrivateRoute>
                  <NoticeForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/circular-Notice"
              element={
                <PrivateRoute>
                  <CircularNotice />
                </PrivateRoute>
              }
            />
            <Route
              path="/credit-note"
              element={
                <PrivateRoute>
                  <CreditNote />
                </PrivateRoute>
              }
            />
            <Route
              path="/member-bill-list"
              element={
                <PrivateRoute>
                  <MemberBill />
                </PrivateRoute>
              }
            />
            <Route
              path="/memeber-list"
              element={
                <PrivateRoute>
                  <Member />
                </PrivateRoute>
              }
            />
            <Route
              path="/receipt"
              element={
                <PrivateRoute>
                  <Receipt />
                </PrivateRoute>
              }
            />
            <Route
              path="/report"
              element={
                <PrivateRoute>
                  <Report />
                </PrivateRoute>
              }
            />
            <Route
              path="/service-provider"
              element={
                <PrivateRoute>
                  <ServiceProvider />
                </PrivateRoute>
              }
            />
            <Route
              path="/notification-sent"
              element={
                <PrivateRoute>
                  <NotificationSent />
                </PrivateRoute>
              }
            />
            <Route
              path="/create-debit-note"
              element={
                <PrivateRoute>
                  <CreateDebitNote />
                </PrivateRoute>
              }
            />
            <Route
              path="/create-assign-role"
              element={
                <PrivateRoute>
                  <CreateAssignRole />
                </PrivateRoute>
              }
            />
            <Route
              path="/add-employee"
              element={
                <PrivateRoute>
                  <AddEmployee />
                </PrivateRoute>
              }
            />
            <Route
              path="/member-table/:role"
              element={
                <PrivateRoute>
                  <MemberTable />
                </PrivateRoute>
              }
            />
            <Route
              path="/compose-notice"
              element={
                <PrivateRoute>
                  <Compose />
                </PrivateRoute>
              }
            />
            <Route
              path="/add-services"
              element={
                <PrivateRoute>
                  <ServiceProviderForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/upload-menu"
              element={
                <PrivateRoute>
                  <UploadMenu />
                </PrivateRoute>
              }
            />
            <Route
              path="/role-management"
              element={
                <PrivateRoute>
                  <RoleManagement />
                </PrivateRoute>
              }
            />
            <Route
              path="/bill"
              element={
                <PrivateRoute>
                  <Bill />
                </PrivateRoute>
              }
            />
            <Route
              path="/ledger"
              element={
                <PrivateRoute>
                  <MemberLadger />
                </PrivateRoute>
              }
            />
            <Route
              path="/debit-note"
              element={
                <PrivateRoute>
                  <MemberDebitNote />
                </PrivateRoute>
              }
            />
            <Route
              path="/credit-note"
              element={
                <PrivateRoute>
                  <MemberCreditNote />
                </PrivateRoute>
              }
            />
            <Route
              path="/receipt"
              element={
                <PrivateRoute>
                  <MemberReciept />
                </PrivateRoute>
              }
            />
            <Route
              path="/get-memeber-recipt"
              element={
                <PrivateRoute>
                  <GetMemeberRecord />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <ProfilePage />
                </PrivateRoute>
              }
            />
            <Route path="/logout" element={<Logout />} />
            <Route
              path="/chat-page/:member_name/:title/:flatNo"
              element={
                <PrivateRoute>
                  <ChatPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/emergency"
              element={
                <PrivateRoute>
                  <Emergency />
                </PrivateRoute>
              }
            />
            <Route
              path="/emergency-list"
              element={
                <PrivateRoute>
                  <EmergencyList />
                </PrivateRoute>
              }
            />
            <Route
              path="/edit-emergency/:emergencyId"
              element={
                <PrivateRoute>
                  <EditEmergency />
                </PrivateRoute>
              }
            />
            <Route
              path="/add-charges"
              element={
                <PrivateRoute>
                  <Charges />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports/:startDate/:endDate/:subject/:memberName"
              element={
                <PrivateRoute>
                  <ReportPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/download-pdf"
              element={
                <PrivateRoute>
                  <DowloadPDF />
                </PrivateRoute>
              }
            />
            <Route
              path="/archive"
              element={
                <PrivateRoute>
                  <Archive />
                </PrivateRoute>
              }
            />
            <Route
              path="/complaints"
              element={
                <PrivateRoute>
                  <ComplatntsRegister />
                </PrivateRoute>
              }
            />
            <Route
              path="/qr-scanner"
              element={
                <PrivateRoute>
                  <QRScaner />
                </PrivateRoute>
              }
            />
            <Route
              path="/qr-page"
              element={
                <PrivateRoute>
                  <QRpage />
                </PrivateRoute>
              }
            />
            <Route
              path="/debit-note-society-name"
              element={
                <PrivateRoute>
                  <DebitNote />
                </PrivateRoute>
              }
            />
            <Route
              path="/bill-society"
              element={
                <PrivateRoute>
                  <BillLists />
                </PrivateRoute>
              }
            />
            <Route
              path="/parking-list"
              element={
                <PrivateRoute>
                  <ParkingList />
                </PrivateRoute>
              }
            />
            <Route
              path="/opening"
              element={
                <PrivateRoute>
                  <Opening />
                </PrivateRoute>
              }
            />
            <Route
              path="/visitor"
              element={
                <PrivateRoute>
                  <Visitor />
                </PrivateRoute>
              }
            />
            <Route
              path="/vouchers"
              element={
                <PrivateRoute>
                  <Vouchers />
                </PrivateRoute>
              }
            />
            <Route
              path="/add-vouchers"
              element={
                <PrivateRoute>
                  <AddVouchers />
                </PrivateRoute>
              }
            />
            <Route
              path="/advance-payment"
              element={
                <PrivateRoute>
                  <AadvancePayment />
                </PrivateRoute>
              }
            />
            <Route
              path="/dynamic-form"
              element={
                <PrivateRoute>
                  <DynamicForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/documents"
              element={
                <PrivateRoute>
                  <Documents />
                </PrivateRoute>
              }
            />
            <Route
              path="/documents-list"
              element={
                <PrivateRoute>
                  <DocumentsList />
                </PrivateRoute>
              }
            />
            <Route
              path="/documents-details"
              element={
                <PrivateRoute>
                  <DocumentDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/add-bank-details"
              element={
                <PrivateRoute>
                  <AddBankDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/bank-details"
              element={
                <PrivateRoute>
                  <BankDetails />
                </PrivateRoute>
              }
            />
            {/* ----------------- new code ---------------- */}
            <Route
              path="/deleted-member-history"
              element={
                <PrivateRoute>
                  <HistroyDeleteRecord />
                </PrivateRoute>
              }
            />
            <Route
              path="/member-history"
              element={
                <PrivateRoute>
                  <HistoryMember />
                </PrivateRoute>
              }
            />
            <Route
              path="/credit-note-history"
              element={
                <PrivateRoute>
                  <HistroyCredit />
                </PrivateRoute>
              }
            />
            <Route
              path="/debit-note-history"
              element={
                <PrivateRoute>
                  <DeleteDebitNote />
                </PrivateRoute>
              }
            />
            <Route
              path="/histroy-opening"
              element={
                <PrivateRoute>
                  <OpeningHistroy />
                </PrivateRoute>
              }
            />
            <Route
              path="/histroy-receipt"
              element={
                <PrivateRoute>
                  <HistroyReceipt />
                </PrivateRoute>
              }
            />
            <Route
              path="/histroy-parking"
              element={
                <PrivateRoute>
                  <ParkingHistory />
                </PrivateRoute>
              }
            />
            <Route
              path="/histroy-deleted-advance"
              element={
                <PrivateRoute>
                  <AadvancePaymentDeleted />
                </PrivateRoute>
              }
            />
            <Route
              path="/histroy-deleted-bill"
              element={
                <PrivateRoute>
                  <BillDeleted />
                </PrivateRoute>
              }
            />
            <Route
              path="/visitor-deleted-list"
              element={
                <PrivateRoute>
                  <VisitorHistroy />
                </PrivateRoute>
              }
            />
             <Route
              path="/previous-year-bills"
              element={
                <PrivateRoute>
                  <PreviousYearBill />
                </PrivateRoute>
              }
            />
             <Route
              path="/previous-year-reciept"
              element={
                <PrivateRoute>
                  <PreviousYearReceipt />
                </PrivateRoute>
              }
            />
             <Route
              path="/previous-year-credit-notes"
              element={
                <PrivateRoute>
                  <PreviousYearCreditNotes />
                </PrivateRoute>
              }
            />
            <Route
              path="/previous-year-debit-notes"
              element={
                <PrivateRoute>
                  <PreviousYearDebitNotes />
                </PrivateRoute>
              }
            />
              <Route
              path="/previous-year-opening"
              element={
                <PrivateRoute>
                  <PreviousYearOpeningBalances />
                </PrivateRoute>
              }
            />
              <Route
              path="/previous-year-advance-payment"
              element={
                <PrivateRoute>
                  <PreviousYearAdvancePayment />
                </PrivateRoute>
              }
            />
             <Route
              path="currently-year-ledger"
              element={
                <PrivateRoute>
                  <CurrentlyYearLedger />
                </PrivateRoute>
              }
            />
            <Route
              path="financial-ledger"
              element={
                <PrivateRoute>
                  <FinancialYearDynamically />
                </PrivateRoute>
              }
            />
             <Route
              path="pervious-year-ledger"
              element={
                <PrivateRoute>
                  <PerviousYearLedger />
                </PrivateRoute>
              }
            />
            <Route
              path="help-support"
              element={
                <PrivateRoute>
                  <HelpSupport />
                </PrivateRoute>
              }
            />
            <Route
              path="employee-rating"
              element={
                <PrivateRoute>
                  <RatingEmp />
                </PrivateRoute>
              }
            />
            <Route
              path="member-request"
              element={
                <PrivateRoute>
                  <MemberRquest />
                </PrivateRoute>
              }
            />
            <Route
              path="rules"
              element={
                <PrivateRoute>
                  <Rules />
                </PrivateRoute>
              }
            />
             <Route
              path="manage-rule"
              element={
                <PrivateRoute>
                  <ManageRules  />
                </PrivateRoute>
              }
            />
              <Route
              path="welcome-uplaod"
              element={
                <PrivateRoute>
                  <PDFBuilder  />
                </PrivateRoute>
              }
            />
            <Route
              path="welcome-management"
              element={
                <PrivateRoute>
                  <UploadManager  />
                </PrivateRoute>
              }
            />
            <Route
              path="guide-line"
              element={
                <PrivateRoute>
                  <PdfGuideLine  />
                </PrivateRoute>
              }
            />
             <Route
              path="guideline-list"
              element={
                <PrivateRoute>
                  <PdfGuideLineList  />
                </PrivateRoute>
              }
            />
              <Route
              path="transaction"
              element={
                <PrivateRoute>
                  <Transaction  />
                </PrivateRoute>
              }
            />
          
             <Route
              path="/add-interest"
              element={
                <PrivateRoute>
                  <Interest  />
                </PrivateRoute>
              }
            />
              <Route
              path="/all-interest"
              element={
                <PrivateRoute>
                  <AllInterest  />
                </PrivateRoute>
              }
            />
             <Route
              path="/bill-master"
              element={
                <PrivateRoute>
                  <BillMaster  />
                </PrivateRoute>
              }
            />
             <Route
              path="/generate-bill"
              element={
                <PrivateRoute>
                  <GenerateBill  />
                </PrivateRoute>
              }
            />
            <Route
              path="/upload-master"
              element={
                <PrivateRoute>
                  <UploadMaster  />
                </PrivateRoute>
              }
            />
              <Route
              path="/member-interest-charges"
              element={
                <PrivateRoute>
                  <MemberInterestCharges  />
                </PrivateRoute>
              }
            />
             <Route
              path="/master-receipt"
              element={
                <PrivateRoute>
                  <MasterReceipt  />
                </PrivateRoute>
              }
            />
              <Route
              path="/society-batch-bills"
              element={
                <PrivateRoute>
                  <SocietyBatchBills  />
                </PrivateRoute>
              }
            />
            <Route
              path="/master-ledger"
              element={
                <PrivateRoute>
                  <MasterLedger  />
                </PrivateRoute>
              }
            />
              <Route
              path="/old-master-data"
              element={
                <PrivateRoute>
                  <MasterOldBill  />
                </PrivateRoute>
              }
            />
              <Route
              path="/pending-bill-member"
              element={
                <PrivateRoute>
                  <PendingBill  />
                </PrivateRoute>
              }
            />
             <Route
              path="/ledger-edit"
              element={
                <PrivateRoute>
                  <LadgerEdit  />
                </PrivateRoute>
              }
            />
             <Route
              path="/ledger-details"
              element={
                <PrivateRoute>
                  <LadgerDetails  />
                </PrivateRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </FilterProvider>
    </React.StrictMode>
  );
}

export default App;


